import { createRouteContext } from '@/providers';
import { TitleDashboardRoute } from '@/types/routes';

const {
    RouteProvider: TitleDashboardRouteProvider,
    useRouteContext: useTitleDashboardRoute,
} = createRouteContext<TitleDashboardRoute>();

export { TitleDashboardRouteProvider, useTitleDashboardRoute };
